import React from "react";
import { tokens } from "../../tokens";
import errorAnim from "../../lottie/error.json";
import { Player } from "@lottiefiles/react-lottie-player";
import leafImg from "../../assets/bolbhai/leaf.png";
import logoSm from "../../assets/bolbhai/brand.png";

type Props = {
  error: Error;
  resetErrorBoundary: () => void;
};

const ErrorFallback: React.FC<Props> = ({ error }) => {
  // ✅ Refresh page when "Try Again" clicked
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-background-quinary">
      <img
        src={logoSm}
        alt="Bolbhai Logo"
        className={`absolute top-8 left-1/2 transform -translate-x-1/2 h-24 w-36 sm:h-32 sm:w-48 pointer-events-none select-none transition-all duration-500 } lg:block
        `}
      />
      <div className="bg-background-secondary border border-background-primary p-7 rounded-none sm:rounded-lg  max-w-md w-full text-center animate-fadeIn">
        {/* ✅ Error Icon on Top */}
        <Player
          autoplay
          loop
          src={errorAnim}
          style={{
            height: tokens.iconSize.xl,
            width: tokens.iconSize.xl,
            marginBottom: tokens.space[4],
          }}
        />

        {/* ✅ Heading */}
        <h2 className="text-feedback-error text-2xl font-semibold font-heading mb-2">
          Oops! Something went wrong.
        </h2>

        {/* ✅ Error Message */}
        <p className="text-md text-text-secondary italic mb-6">
          {error.message}
        </p>

        {/* ✅ Try Again Button (with tokens + Tailwind) */}
        <button
          onClick={handleReload}
          className="
            px-6 py-2 bg-primary-base/90 text-background-secondary rounded-md font-semibold hover:shadow-lg transition-all duration-200 hover:brightness-105 active:scale-95
          "
        >
          Try again
        </button>
      </div>

      {/* Left Leaf */}
      <img
        src={leafImg}
        alt="Leaf Decoration Left"
        className="
    hidden lg:block
    absolute bottom-0 left-1 w-24 sm:w-32 md:left-24 md:w-32 lg:left-40 lg:w-32
    pointer-events-none select-none
    transform transition-all duration-500
  "
      />

      {/* Right Leaf */}
      <img
        src={leafImg}
        alt="Leaf Decoration Right"
        className="
    hidden lg:block
    absolute bottom-0 right-1 w-24 sm:w-32 md:right-24 md:w-32 lg:right-40 lg:w-32
    pointer-events-none select-none
    transform scale-x-[-1] transition-all duration-500
  "
      />
    </div>
  );
};

export default ErrorFallback;

// import React from 'react';
// import { tokens } from '../../tokens';
// import errorAnim from "../../lottie/error.json";
// import { Player } from "@lottiefiles/react-lottie-player";

// type Props = {
//   error: Error;
//   resetErrorBoundary: () => void;
// };

// const ErrorFallback: React.FC<Props> = ({ error, resetErrorBoundary }) => {
//   return (
//     <div
//       style={{
//         ...tokens.layout.center,
//         minHeight: tokens.viewport.fullHeight,
//         background: tokens.color.background.quinary,
//         padding: tokens.space[12],
//       }}
//     >
//       <div
//         style={{
//           background: tokens.color.background.secondary,
//           borderRadius: tokens.radius.lg,
//           padding: tokens.space[8],
//           maxWidth: tokens.maxWidth.md,
//           width: '100%',
//           textAlign: 'center',
//           animation: tokens.animations.fadeIn,
//         }}
//       >
//         {/* ✅ Error Icon on Top */}
//         <Player
//           autoplay
//           loop
//           src={errorAnim}
//           style={{
//             height: tokens.iconSize.xl,
//             width: tokens.iconSize.xl,
//             marginBottom: tokens.space[4],
//           }}
//         />

//         {/* ✅ Heading */}
//         <h2
//           style={{
//             color: tokens.color.feedback.error,
//             fontSize: tokens.font.size.heading.h4,
//             fontWeight: tokens.font.weight.semibold,
//             fontFamily: tokens.font.family.heading,
//             marginBottom: tokens.space[2],
//           }}
//         >
//           Oops! Something went wrong.
//         </h2>

//         {/* ✅ Error Message */}
//         <p
//           style={{
//             fontSize: tokens.font.size.md,
//             color: tokens.color.text.secondary,
//             fontStyle: 'italic',
//             marginBottom: tokens.space[6],
//           }}
//         >
//           {error.message}
//         </p>

//         {/* ✅ Try Again Button */}
//         <button
//           onClick={resetErrorBoundary}
//           style={{
//             backgroundColor: tokens.color.background.primary,
//             color: tokens.color.text.light,
//             fontSize: tokens.font.size.md,
//             fontWeight: tokens.font.weight.medium,
//             padding: `${tokens.space[4]} ${tokens.space[8]}`,
//             borderRadius: tokens.radius.md,
//             cursor: tokens.cursor.pointer,
//             border: 'none',
//             transition: tokens.interactions.transitions.default,
//             boxShadow: tokens.shadow.hover,
//             minWidth: '120px',
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.filter = tokens.interactions.hover.filter;
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.filter = 'none';
//           }}
//         >
//           Try again
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ErrorFallback;